import React from "react"
import { Link } from "gatsby"

import * as style from "./DeprecatedItems.module.scss"

const DeprecatedItem = ({ item, microcopy }) => (
  <Link to={item.path} className={style.link}>
    <span>
      {`${item.title} ${`v${item.version}`}`}
    </span>
  </Link>
)

export default DeprecatedItem
